import { useEffect, useState } from "react";
import { endpoint } from "../../../../../views/pages/manage/common/constant";
import useCashierOfficeDropdown from "../../../../../views/pages/manage/common/hook/useCashierOfficeDropdown";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const useFetchDropdown = () => {
    const [dropdownValues, setDropdownValues] = useState({
      terms: [],
      courseIds: [],
      cashierOffices: [],
      receiptTypes: [
        { label: "EPMR", value: "EPMR" },
        { label: "Cash", value: "CASH" },
      ],
    });
  
    const { items } = useCashierOfficeDropdown({
      label: "Cashier office",
      formHandler: () => {},
      inputHeight: "9px",
    });
  
    useEffect(() => {
      const fetchStaticDropdowns = async () => {
        try {
          const [terms, courseIds] = await Promise.all([
            dropdownMapping(endpoint?.term?.getAllActive, "termDispValue", "termDispValue"),
            dropdownMapping(
              endpoint.courseCatelogMapping.getAllActiveCourseIds,
              "courseIds"
            ),
          ]);
  
          setDropdownValues((prev) => ({
            ...prev,
            terms,
            courseIds,
          }));
        } catch (err) {
          console.error("Failed to fetch dropdowns:", err);
        }
      };
  
      fetchStaticDropdowns();
    }, []);
  
    useEffect(() => {
      if (!items) return;
  
      setDropdownValues((prev) => ({
        ...prev,
        cashierOffices: items,
      }));
    }, [items]); 
  
    return dropdownValues;
  };